import React, { useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { pincodeValidity, updateAddressAPI } from "../../utiils/api";
import { toast } from "react-toastify";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { GridLoader } from "react-spinners";

function AddressUpdate({
  brandConfig,
  validationConfig,
  order,
  addressBucket,
  updatedAddress,
  setAddressBucket,
  setUpdatedAddress,
}) {
  const [pin, setPin] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [landmark, setLandmark] = useState("");
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [remainingFields, setRemainingFields] = useState(false);
  const [isAddressUpdated, setIsAddressUpdated] = useState(
    addressBucket && addressBucket.address_updated
  );
  const [updatingAddress, setUpdatingAddress] = useState(false);

  const InputsBlock = ({
    value1,
    setValue1,
    label1,
    value2,
    setValue2,
    label2,
    disabled,
  }) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginTop: "20px",
        }}
      >
        <TextField
          type="text"
          required
          defaultValue={value1}
          onChange={(e) => {
            setValue1(e.target.value);
          }}
          className="input1"
          label={label1}
          disabled={disabled}
        />
        <TextField
          type="text"
          required
          defaultValue={value2}
          onChange={(e) => {
            setValue2(e.target.value);
          }}
          className="input2"
          label={label2}
          disabled={disabled}
        />
      </div>
    );
  };

  const validatePincode = () => {
    setPincodeLoading(true);
    pincodeValidity(pin).then((resp) => {
      setState(resp.data.data.state);
      setCity(resp.data.data.city);
      setRemainingFields(true);
      setPincodeLoading(false);
    });
  };

  const handleAddressUpdate = (e) => {
    e.preventDefault();
    if (
      (addressLine1.length + addressLine2.length) >
      (validationConfig && validationConfig !==null && validationConfig.min_address_character_length)
    ) {
      setUpdatingAddress(true);
      updateAddressAPI(
        addressBucket.identifier,
        addressBucket.order_id,
        pin,
        city,
        state,
        addressLine1,
        addressLine2,
        landmark
      )
        .then((resp) => {
          toast.success("Address updated", {
            postion: toast.POSITION.TOP_LEFT,
            autoClose: 6000,
            hideProgressBar: false,
          });
          setAddressBucket(resp.data.data.address_bucket);
          setUpdatedAddress(resp.data.data.corrected_order_info);
          setIsAddressUpdated(true);
        })
        .catch((err) => {
          toast.error("Something went wrong. Please try again", {
            postion: toast.POSITION.TOP_LEFT,
            autoClose: 6000,
            hideProgressBar: false,
          });
        })
        .finally(() => {
          setUpdatingAddress(false);
        });
    } else {
      toast.error(
        `Address should contain at least ${validationConfig.min_address_character_length} characters`,
        {
          postion: toast.POSITION.TOP_LEFT,
          autoClose: 6000,
          hideProgressBar: false,
        }
      );
    }
  };

  useEffect(() => {
    if (pin && pin.length === 6) {
      setRemainingFields(false);
      validatePincode();
    }
  }, [pin]);

  return (
    <div>
      {order && order !== null && order.is_cancelled ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            flexDirection: "column",
          }}
        >
          <SentimentVeryDissatisfiedIcon
            style={{
              fontSize: "60px",
              marginBottom: "10px",
              color:
                brandConfig &&
                brandConfig !== null &&
                brandConfig.primary_theme_color,
            }}
          />
          <p style={{ fontSize: "20px", textAlign: "center" }}>
            We are very sorry to hear that your order is cancelled.
          </p>
        </div>
      ) : order && order !== null && order.order_fulfilled ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            flexDirection: "column",
          }}
        >
          <LocalShippingIcon
            style={{
              fontSize: "60px",
              marginBottom: "10px",
              color:
                brandConfig &&
                brandConfig !== null &&
                brandConfig.primary_theme_color,
            }}
          />
          <p style={{ fontSize: "20px", textAlign: "center" }}>
            Your order has already been dispatched/delivered.
          </p>
        </div>
      ) : isAddressUpdated ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "400px",
            flexDirection: "column",
          }}
        >
          <TaskAltIcon style={{ fontSize: "60px", color: "#00D400" }} />
          <p
            style={{ fontWeight: "600", fontSize: "20px", margin: "10px 0px" }}
          >
            Successfully updated.
          </p>
          {updatedAddress && updatedAddress !== null && (
            <p style={{ textAlign: "center" }}>
              Your updated address is {updatedAddress.address1},{" "}
              {updatedAddress.address2}, {updatedAddress.landmark}{" "}
              {updatedAddress.landmark &&
                updatedAddress.landmark !== null &&
                updatedAddress.landmark.length > 0 &&
                ","}{" "}
              {updatedAddress.city} - {updatedAddress.pincode},{" "}
              {updatedAddress.state}, {updatedAddress.country}{" "}
            </p>
          )}
        </div>
      ) : (
        <div>
          <p
            className="fs-18"
            style={{
              textDecoration: "underline",
              textUnderlineOffset: "10px",
              textDecorationThickness: "2px",
            }}
          >
            Update Address
          </p>
          <div
            style={{
              background: "#ECB90D22",
              display: "flex",
              padding: "15px",
              border: "1px solid #ECB90D",
              borderRadius: "4px",
              margin: "20px 0px",
            }}
          >
            <ErrorIcon
              color="#ECB90D"
              style={{ marginRight: "10px", color: "#ECB90D" }}
            />{" "}
            Address is incomplete
          </div>

          <form
            style={{ marginTop: "30px" }}
            onSubmit={(e) => handleAddressUpdate(e)}
          >
            {/* <TextField label="Pincode" /> */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                type="text"
                required
                value={pin}
                onChange={(e) => {
                  setPin(e.target.value);
                }}
                className="input1"
                label="Pincode"
              />
              <Button
                style={{
                  color:
                    brandConfig &&
                    brandConfig !== null &&
                    brandConfig.primary_theme_color,
                  textTransform: "capitalize",
                  padding: "14px 24px",
                  marginLeft: "16px",
                }}
                variant="text"
                onClick={() => validatePincode()}
              >
                Check
              </Button>
            </div>
            {pincodeLoading && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "250px",
                }}
              >
                <GridLoader
                  color={
                    brandConfig &&
                    brandConfig !== null &&
                    brandConfig.primary_theme_color
                  }
                  size={10}
                />
              </div>
            )}
            {remainingFields && (
              <div>
                <InputsBlock
                  value1={city}
                  value2={state}
                  setValue1={setCity}
                  setValue2={setState}
                  label1="City"
                  label2="State"
                  disabled={true}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    marginTop: "20px",
                  }}
                >
                  <TextField
                    type="text"
                    required
                    value={addressLine1}
                    onChange={(e) => {
                      setAddressLine1(e.target.value);
                    }}
                    className="input1"
                    label="Address Line 1"
                  />
                  <TextField
                    type="text"
                    required
                    value={addressLine2}
                    onChange={(e) => {
                      setAddressLine2(e.target.value);
                    }}
                    className="input2"
                    label="Address Line 2"
                  />
                </div>
                <TextField
                  required={
                    validationConfig &&
                    validationConfig !== null &&
                    validationConfig.landmark_required
                  }
                  label="Landmark"
                  placeholder={`${
                    validationConfig &&
                    validationConfig !== null &&
                    validationConfig.landmark_required
                      ? ""
                      : "(Optional)"
                  }`}
                  fullWidth
                  style={{ marginTop: "20px" }}
                  onChange={(e) => setLandmark(e.target.value)}
                />
                <Button
                  type="submit"
                  disabled={updatingAddress}
                  style={{
                    margin: "40px auto 0px",
                    display: "block",
                    padding: "16px 20px",
                    background:
                      brandConfig &&
                      brandConfig !== null &&
                      brandConfig.primary_theme_color,
                    color:
                      brandConfig &&
                      brandConfig !== null &&
                      brandConfig.secondary_theme_color,
                    textTransform: "capitalize",
                  }}
                  endIcon={
                    !updatingAddress ? (
                      ""
                    ) : (
                      <GridLoader
                        color={
                          brandConfig &&
                          brandConfig !== null &&
                          brandConfig.secondary_theme_color
                        }
                        size={10}
                        style={{ marginleft: "10px" }}
                      />
                    )
                  }
                  variant="contained"
                >
                  {!updatingAddress ? "Update Address " : "Updating "}
                </Button>
              </div>
            )}
          </form>
        </div>
      )}
    </div>
  );
}

export default AddressUpdate;
